import { useTranslation } from 'next-i18next';
export function BuildLoading() {
  const {
    t
  } = useTranslation(['build']);
  return <div className={'flex h-[100vh] w-[100vw] flex-col items-center justify-center'} data-sentry-component="BuildLoading" data-sentry-source-file="BuildLoading.tsx">
      <img className={'rounded-[8px]'} src="/assets/buildLoading.gif" alt="loading" />
      <div className={'pt-[16px] text-[18px] font-bold text-gray-700'}>
        {t('build.loading.message')}
      </div>
    </div>;
}